import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import VendorCard from './Card'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { makePropertyVendorsSelector } from 'selectors/vendor'


let select = dirtyRead(
	(state, props) => {
		let propertyVendors = makePropertyVendorsSelector()
		return ({
			property: doc(state, props.propertyID)
		  , vendors: propertyVendors(state, props)
		})
	}
)

export class VendorList extends Component {
	render() {
		let { props } = this
	    return(
			<div>
				<List
					style={{
						backgroundColor: "transparent"
						, paddingTop: "0"
					}}
				>
					{(R.keys(props.vendors).length)?
						R.map(vendor => <VendorCard vendorId={vendor._id} />, props.vendors)
						: null
					}
				</List>
			</div>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(VendorList)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/vendors/List.js